import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import {getAslProtocols} from "../../util/Validations";
import {ASL_ASSET_TYPE} from "../../util/Constants";
import {AslDeviceOverviewContext} from "./context/AslDeviceOverviewContext";
import CommonDeviceLogstream from "../../commonui/CommonDeviceLogstream";

const AslDeviceLogstream = ({intl}) => {

    const {viewModel, dispatch} = useContext(AslDeviceOverviewContext);
    const deviceList = Object.values(viewModel.aslDeviceInformation);

    const props = {
        protocols: getAslProtocols(),
        dispatch,
        deviceList,
        deviceType: ASL_ASSET_TYPE,
        intl
    }
    return (
        <Column>
            <CommonDeviceLogstream {...props}/>
        </Column>
    );
}

export default injectIntl(AslDeviceLogstream)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/AslDeviceLogstream.js